// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '../../../helpers';
import Button from '../../button';
import type { Theme } from '../../../types';

const Container = styled<any, Theme>('div')`
  display: flex;
  flex-direction: column;

  ${media.md(css`
    flex-direction: row;
    justify-content: space-between;
  `)}

  ${media.lg(css`
    justify-content: flex-start;
  `)}
`;

const Title = styled<any, Theme>('h3')`
  color: ${props => props.theme.faq.feedback.title.color};
  font-weight: ${props => props.theme.faq.feedback.title.fontWeight};
  font-size: 1rem;
  line-height: 1.2em;
  margin-bottom: 1em;

  ${media.md(css`
    line-height: 2.5em;
  `)}

  ${media.lg(css`
    margin-right: 2.25rem;
  `)}
`;

const Options = styled<any, Theme>('div')`
  display: flex;
  justify-content: space-between;

  ${media.md(css`
    justify-content: flex-end;
  `)}
`;

const OptionButton = styled<typeof Button, Theme>(Button)`
  min-width: auto;
  margin: 0;
  padding: 0.5em 1em;

  ${media.md(css`
    margin-right: 0.5rem;
    padding: 0.5em 2em;

    &:last-child {
      margin-right: 0;
    }
  `)}
`;

type Props = {|
  activeFeedback: string | boolean,
  canAnswer?: boolean, // eslint-disable-line react/require-default-props
  className?: string, // eslint-disable-line react/require-default-props
  onSubmit: Function,
  title: string,
  wasHelpful: string,
  wasNotHelpful: string,
  wasPartiallyHelpful: string,
|};

export default ({
  activeFeedback,
  canAnswer = false,
  className,
  onSubmit,
  title,
  wasHelpful,
  wasNotHelpful,
  wasPartiallyHelpful,
}: Props) => (
  <Container className={className}>
    <Title>{title}</Title>
    <Options>
      <OptionButton
        colors="primary"
        onClick={canAnswer ? () => onSubmit('yes') : null}
        size="small"
        variant={activeFeedback === 'yes' ? 'default' : 'ghost'}
      >
        {wasHelpful}
      </OptionButton>
      <OptionButton
        colors="primary"
        onClick={canAnswer ? () => onSubmit('no') : null}
        size="small"
        variant={activeFeedback === 'no' ? 'default' : 'ghost'}
      >
        {wasNotHelpful}
      </OptionButton>
      <OptionButton
        colors="primary"
        onClick={canAnswer ? () => onSubmit('partial') : null}
        size="small"
        variant={activeFeedback === 'partial' ? 'default' : 'ghost'}
      >
        {wasPartiallyHelpful}
      </OptionButton>
    </Options>
  </Container>
);
